import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import MyStory from './pages/MyStory';
import ProductDeepDives from './pages/ProductDeepDives';
import CaseStudy from './pages/CaseStudy';
import IndustryWork from './pages/IndustryWork';
import Contact from './pages/Contact';
import { caseStudies } from './data/CaseStudyData';
// ScrollToTop component to ensure navigation always starts at the top of the page
function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
export function App() {
  return <Router data-id="element-0">
      <div className="flex flex-col min-h-screen bg-gray-900" data-id="element-1">
        <ScrollToTop data-id="element-2" />
        <Navbar data-id="element-3" />
        <main className="flex-grow" data-id="element-4">
          <Routes data-id="element-5">
            <Route path="/" element={<Home data-id="element-7" />} data-id="element-6" />
            <Route path="/my-story" element={<MyStory data-id="element-9" />} data-id="element-8" />
            <Route path="/product-deep-dives" element={<ProductDeepDives data-id="element-11" />} data-id="element-10" />
            <Route path="/case-study/1" element={<CaseStudy caseStudy={caseStudies[0]} data-id="element-13" />} data-id="element-12" />
            <Route path="/case-study/2" element={<CaseStudy caseStudy={caseStudies[1]} data-id="element-15" />} data-id="element-14" />
            <Route path="/case-study/3" element={<CaseStudy caseStudy={caseStudies[2]} data-id="element-17" />} data-id="element-16" />
            <Route path="/case-study/4" element={<CaseStudy caseStudy={caseStudies[3]} data-id="element-19" />} data-id="element-18" />
            <Route path="/industry-work/:id" element={<IndustryWork data-id="element-21" />} data-id="element-20" />
            <Route path="/contact" element={<Contact data-id="element-23" />} data-id="element-22" />
          </Routes>
        </main>
        <Footer data-id="element-24" />
      </div>
    </Router>;
}